<template>
  <v-container fluid class="admin-facility">
    <v-tabs v-model="tabIndex">
      <v-tab>{{ $t('admin_acc_facility_type.title') }}</v-tab>
      <v-tab-item>
        <ItemTypeList full-height
                      @edit="onItemTypeEdit"
                      v-if="tabIndex === 0"></ItemTypeList>
        <EditItemTypeModal :item-type-id="editingItemTypeId"
                           :shown="editItemTypeModalShown"
                           @cancel="onEditItemTypeModalFinish"></EditItemTypeModal>
      </v-tab-item>

      <v-tab>{{ $t('admin_acc_location.title') }}</v-tab>
      <v-tab-item>
        <LocationList full-height
                      @edit="onLocationEdit"
                      v-if="tabIndex === 1"></LocationList>

        <EditLocationModal :location-id="editingLocationId"
                           :shown="editLocationModalShown"
                           @cancel="onEditLocationModalFinish"></EditLocationModal>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import ItemTypeList from "@/components/acc_booking/item_type/ItemTypeList";
import LocationList from "@/components/acc_booking/location/LocationList";
import {ref} from "@vue/composition-api";
import EditItemTypeModal from "@/components/acc_booking/item_type/EditItemTypeModal";
import EditLocationModal from "@/components/acc_booking/location/EditLocationModal";

export default {
  name: 'AccBookingFacility',
  components: {EditLocationModal, EditItemTypeModal, LocationList, ItemTypeList},
  setup(props, {root}) {
    const tabIndex = ref(0);

    const editingItemTypeId = ref(null);
    const editItemTypeModalShown = ref(false);
    const onItemTypeEdit = function (item) {
      editingItemTypeId.value = item.id;
      editItemTypeModalShown.value = true;
    };
    const onEditItemTypeModalFinish = function () {
      editingItemTypeId.value = null;
      editItemTypeModalShown.value = false;
    }

    const editingLocationId = ref(null);
    const editLocationModalShown = ref(false);
    const onLocationEdit = function (item) {
      editingLocationId.value = item.id;
      editLocationModalShown.value = true;
    };
    const onEditLocationModalFinish = function () {
      editingLocationId.value = null;
      editLocationModalShown.value = false;
    }

    return {
      tabIndex,

      editingItemTypeId,
      editItemTypeModalShown,
      onItemTypeEdit,
      onEditItemTypeModalFinish,

      editingLocationId,
      editLocationModalShown,
      onLocationEdit,
      onEditLocationModalFinish,
    }
  },
}
</script>

<style lang="less">
.admin-facility {
  height: 100%;
  display: flex;
  flex-direction: column;

  .v-tabs {
    .v-tabs-bar {
      flex: 0 0 auto;
    }

    .v-tabs-items {
      height: calc(100% - 48px);
      flex: 1 1 0;

      .v-window__container {
        height: 100% !important;

        .v-window-item {
          height: 100% !important;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
</style>
